import Controller from "./redirector.controller";
import template from "./redirector.html";

const redirector = {
  template,
  controller: Controller,
};

export default redirector;



// WEBPACK FOOTER //
// ./src/pages/redirector/redirector.component.js